import { createFileRoute } from "@tanstack/react-router";
import Checkout from "@/pages/Checkout";
import { buildNoindexHead, noindexLoader, type NoindexSEO } from "@/lib/noindex-route-seo";

const TITLES: NoindexSEO = {
  "es": "Checkout",
  "pt-BR": "Checkout",
  "en": "Checkout",
  "en-EU": "Checkout",
};

export const Route = createFileRoute("/checkout")({
  loader: noindexLoader,
  head: ({ loaderData }) => buildNoindexHead(TITLES, "/checkout", loaderData),
  component: Checkout,
});
